import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store/index'
import ElementUI from 'element-ui'
import './static/styles/theme-blue/index.css' // 浅绿色主题
import i18n from '@/lang' // 国际化

// import { btnPermission, includePermission } from './utils/permission'
import Pagination from '@/components/Pagination'
// import permission from './directive/permission'
import { baseImgUrl } from './utils/config'

import 'nprogress/nprogress.css' // progress bar style
import './static/styles/index.scss'

import '@/static/icons'

// import { OSSclient } from './utils/oss'
// use
import Viewer from 'v-viewer' // 引入js
import './static/styles/viewer.css'
Viewer.setDefaults({
  // navbar: true, //底部缩略图
  toolbar: {
    zoomIn: true,
    zoomOut: true,
    reset: true,
    prev: true,
    next: true,
    rotateLeft: true,
    rotateRight: true,
    flipHorizontal: true,
    flipVertical: true,
  }
})
Vue.use(Viewer) // 默认配置写法

Vue.use(ElementUI, {
  size: 'medium' // set element-ui default size
})
Vue.config.productionTip = false
Vue.prototype.baseImgUrl = baseImgUrl
// Vue.prototype.checkBtnPermission = btnPermission // 检查方法权限
// Vue.prototype.includePermission = includePermission // 检查方法列表权限
// Vue.prototype.OSSclient = OSSclient

// 全局组件挂载
Vue.component('Pagination', Pagination)

// Vue.use(permission)

new Vue({
  router,
  // store,
  i18n,
  render: h => h(App)
}).$mount('#app')
